import type { TFunction } from 'i18next';

import yup from '../../../shared/validation';

export function getExerciseValidation(t: TFunction) {
  return yup.object({
    title: yup
      .string()
      .max(256, t('formikValidation.maxLength').replace('{0}', '256'))
      .required(t('formikValidation.nameRequired')),
    category: yup.object().required(t('formikValidation.categoryRequired')),
    mainMuscleGroup: yup
      .object()
      .required(t('formikValidation.mainMuscleGroupRequired')),
    equipment: yup.object().required(t('formikValidation.equipmentRequired')),
    language: yup.object().required(t('formikValidation.languageRequired')),
    options: yup
      .array()
      .max(4, t('formikValidation.exerciseOptionsMax').replace('{0}', '4')),
  });
}
